import { Box, Button } from "@mui/material"
// import {
//     Google as GoogleIcon,
//     Apple as AppleIcon,
//     Facebook as FacebookIcon,
// } from '@mui/icons-material'
import GoogleIcon from '@mui/icons-material/Google'
// import AppleIcon from '@mui/icons-material/Apple'
// import FacebookIcon from '@mui/icons-material/Facebook'
import { useUserContext } from 'strview-common'



const LoginFederatedForm = () => {
    // const clientId = process.env.REACT_APP_CLIENT_ID
    // const hostedUIEndpoint = `https://${process.env.REACT_APP_AWS_HOSTED_UI_DOMAIN}.auth.${process.env.REACT_APP_AWS_REGION}.amazoncognito.com/oauth2/authorize?client_id=${clientId}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+profile&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Flogin-interstitial`
    const { getFedAuthUrl } = useUserContext()

    const {url: hostedUIEndpoint} = getFedAuthUrl('login')

    return (
        <>
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    href={hostedUIEndpoint}
                    endIcon={
                        <>
                            
                            <GoogleIcon />
                            
                        </>
                    }
                >
                    Sign in with Google
                </Button>
            </Box>
        </>
    )
}

export default LoginFederatedForm